import apiClient from "@/api/client";
import { saveBlobResponse } from "@/utils/download";
import type { ContractorProjectMap, MapScope, MegamapProject } from "./types";

const BASE = "/power-projects/contractor";

// Tryb podglądu „oczami podwykonawcy" (wewnętrzni z bramką modułu ZE): te same
// endpointy z jawnym as_contractor — backend zwraca w meta nazwę firmy do banera.
const previewParams = (asContractor?: string) =>
  asContractor ? { params: { as_contractor: asContractor } } : undefined;

export interface MegamapResult {
  projects: MegamapProject[];
  previewName: string | null;
}

export const getContractorMegamap = async (
  asContractor?: string,
): Promise<MegamapResult> => {
  const r = await apiClient.get(`${BASE}/megamap/`, previewParams(asContractor));
  return {
    projects: r.data.data.projects,
    previewName: r.data.meta?.preview_contractor_name ?? null,
  };
};

export interface ProjectMapResult {
  project: ContractorProjectMap;
  previewName: string | null;
}

export const getContractorProjectMap = async (
  connectionId: string,
  asContractor?: string,
): Promise<ProjectMapResult> => {
  const r = await apiClient.get(
    `${BASE}/projects/${connectionId}/`,
    previewParams(asContractor),
  );
  return {
    project: r.data.data,
    previewName: r.data.meta?.preview_contractor_name ?? null,
  };
};

// Wykaz działek — autoryzowany widok Django, więc blob przez klienta API.
export const downloadContractorParcels = async (
  connectionId: string,
  scope: MapScope,
  fileFormat: "xlsx" | "csv",
  asContractor?: string,
) => {
  const resp = await apiClient.post(
    `${BASE}/projects/${connectionId}/export/`,
    {
      scope,
      file_format: fileFormat,
      ...(asContractor ? { as_contractor: asContractor } : {}),
    },
    { responseType: "blob" },
  );
  saveBlobResponse(resp, `Dzialki.${fileFormat}`);
};
